import { createContext } from 'utils/react-helpers';

const [UserProvider, useUser] = createContext({ name: 'UserContext' });

export { UserProvider, useUser };
